var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupancyRateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 11.8972C23.1444 11.6592 23.0964 11.4236 23.0019 11.2052C22.9074 10.9868 22.7686 10.7904 22.5941 10.6286L11.9998 0.857178L1.40554 10.6286C1.23107 10.7904 1.0922 10.9868 0.99775 11.2052C0.903305 11.4236 0.855363 11.6592 0.856973 11.8972V21.4286C0.856973 21.8832 1.03758 22.3193 1.35908 22.6408C1.68057 22.9622 2.11661 23.1429 2.57125 23.1429H21.4284C21.883 23.1429 22.3191 22.9622 22.6405 22.6408C22.9621 22.3193 23.1426 21.8832 23.1426 21.4286V11.8972Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5697 17.1445H12.4286C12.1919 17.1445 12 17.3364 12 17.5731V22.7142C12 22.9509 12.1919 23.1428 12.4286 23.1428H17.5697C17.8064 23.1428 17.9983 22.9509 17.9983 22.7142V17.5731C17.9983 17.3364 17.8064 17.1445 17.5697 17.1445Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupancyRateIcon);
export default __webpack_public_path__ + "static/media/OccupancyRateIcon.abe2693d5f6c4272e061eb9ef899a6b7.svg";
export { ForwardRef as ReactComponent };